function lockScrollMobile() {
    document.body.style.overflow = "hidden";
}
function unlockScrollMobile() {
    document.body.style.overflow = "";
}
/** Normalize tab href to a pathname for active-state checks (handles absolute URLs from CMS). */
function normalizeNavTabHref(href) {
    const value = href.trim();
    if (!value || value === "#") {
        return "#";
    }
    try {
        const { pathname } = new URL(value, window.location.origin);
        const path = pathname.toLowerCase();
        if (path.length > 1 && path.endsWith("/")) {
            return path.slice(0, -1);
        }
        return path || "/";
    }
    catch {
        const path = value.toLowerCase();
        if (path.length > 1 && path.endsWith("/")) {
            return path.slice(0, -1);
        }
        return path.startsWith("/") ? path || "/" : path;
    }
}
function getCurrentPagePath() {
    const path = window.location.pathname.toLowerCase();
    if (path.length > 1 && path.endsWith("/")) {
        return path.slice(0, -1);
    }
    return path || "/";
}
export function Header(element) {
    const headerHeight = element.offsetHeight;
    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
    // Cache values that don't change for the page lifecycle. Avoids URL parsing
    // and DOM lookups on every nav-tab hover.
    const currentPagePath = getCurrentPagePath();
    const currentLanguage = document.documentElement.lang?.toLowerCase() || "";
    let isMenuOpen = false;
    let isMobileMenuOpen = false;
    let hoverTimeout = null;
    const menuPanel = document.querySelector("[data-menu-panel]");
    const menuBackdrop = document.querySelector("[data-menu-backdrop]");
    const closeButtons = document.querySelectorAll("[data-action='close-menu']");
    const menuContentSections = document.querySelectorAll("[data-menu-content]");
    const mobileMenuToggle = element.querySelector("[data-action='mobile-menu']");
    const hamburgerIcon = mobileMenuToggle?.querySelector("[data-hamburger-icon]");
    const mobileMenu = document.querySelector("[data-mobile-menu]");
    const mobileLevel0 = document.querySelector("[data-mobile-level='0']");
    const mobilePanels = document.querySelectorAll("[data-mobile-panel]");
    const languageButton = document.querySelector("[data-action='language']");
    const languageDropdown = document.querySelector("[data-language-dropdown]");
    // Cache nav tabs and tag the current-page tab once so hover handlers
    // don't have to re-parse URLs on every mouseenter.
    const allNavTabs = element.querySelectorAll("[data-nav-tab]");
    allNavTabs.forEach((tab) => {
        const navPath = normalizeNavTabHref(tab.getAttribute("href") || "");
        if (navPath === "#")
            return;
        const isHomePage = navPath === "/" || (currentLanguage.length > 0 && navPath === `/${currentLanguage}`);
        const matches = isHomePage
            ? currentPagePath === "/" ||
                currentPagePath === `/${currentLanguage}` ||
                currentPagePath === ""
            : currentPagePath === navPath || currentPagePath.startsWith(`${navPath}/`);
        if (matches) {
            tab.setAttribute("data-current-page", "true");
        }
    });
    // =========================================================================
    // MEGA MENU FUNCTIONS - Just show/hide server-rendered panels
    // =========================================================================
    const openMegaMenuForItem = (navTab, menuSlug) => {
        const contentSection = document.querySelector(`[data-menu-content="${menuSlug}"]`);
        if (!contentSection)
            return;
        clearLevel2Hover();
        navTab.setAttribute("aria-expanded", "true");
        menuContentSections.forEach((section) => {
            section.classList.remove("block");
            section.classList.add("hidden");
        });
        contentSection.classList.remove("hidden");
        contentSection.classList.add("block");
        if (!isMenuOpen) {
            isMenuOpen = true;
            menuPanel?.setAttribute("data-state", "open");
            menuBackdrop?.setAttribute("data-state", "visible");
        }
        const emptyState = contentSection.querySelector("[data-empty-state]");
        const firstLevel2Id = emptyState?.getAttribute("data-first-level2");
        const firstLevel2Item = contentSection.querySelector(`[data-hover-level2="${firstLevel2Id}"]`);
        if (firstLevel2Item) {
            handleLevel2Hover(firstLevel2Item);
        }
        else {
            if (emptyState) {
                emptyState.setAttribute("data-visible", "true");
                const emptyStateMessage = emptyState.querySelector("[data-empty-state-message]");
                if (emptyStateMessage) {
                    const messageTemplate = emptyStateMessage.getAttribute("data-message-template") ||
                        "Visit the {0} page for more information";
                    emptyStateMessage.textContent = messageTemplate.replace("{0}", navTab.textContent?.trim() || "");
                }
            }
        }
    };
    /** True when this tab represents the current page (tagged once at init). */
    const isCurrentPageTab = (tab) => tab.getAttribute("data-current-page") === "true";
    const resetNavTabStates = () => {
        allNavTabs.forEach((tab) => {
            if (isCurrentPageTab(tab)) {
                tab.setAttribute("data-state", "active");
            }
            else {
                tab.removeAttribute("data-state");
            }
            tab.setAttribute("aria-expanded", "false");
        });
    };
    const closeMegaMenu = () => {
        isMenuOpen = false;
        if (menuPanel) {
            menuPanel.setAttribute("data-state", "closed");
        }
        menuBackdrop?.removeAttribute("data-state");
        clearLevel2Hover();
        menuContentSections.forEach((section) => {
            section.classList.remove("block");
            section.classList.add("hidden");
        });
        resetNavTabStates();
    };
    // =========================================================================
    // LEVEL 2 HOVER FUNCTIONS (Desktop Mega Menu)
    // Handle hover on Level 2 items to show Level 3+ content
    // =========================================================================
    let hoveredLevel2Item = null;
    const handleLevel2Hover = (level2Item) => {
        const activePanel = document.querySelector("[data-menu-panel][data-state='open']");
        if (!activePanel)
            return;
        const level2Id = level2Item.getAttribute("data-hover-level2");
        if (!level2Id)
            return;
        const isSwitchingLevel2 = hoveredLevel2Item !== level2Item;
        if (hoveredLevel2Item && hoveredLevel2Item !== level2Item) {
            hoveredLevel2Item.classList.remove("bg-primary", "text-white");
            hoveredLevel2Item.classList.add("text-gray-700", "hover:bg-gray-100");
        }
        hoveredLevel2Item = level2Item;
        level2Item.classList.add("bg-primary", "text-white");
        level2Item.classList.remove("text-gray-700", "hover:bg-gray-100");
        const activeContentSection = activePanel.querySelector("[data-menu-content].block");
        if (!activeContentSection)
            return;
        activeContentSection
            .querySelectorAll("[data-level3-panel], [data-empty-state]")
            .forEach((el) => {
            el.setAttribute("data-visible", "false");
        });
        const emptyState = activeContentSection.querySelector("[data-empty-state]");
        const targetLevel3Panel = activeContentSection.querySelector(`[data-level3-panel="${level2Id}"]`);
        if (targetLevel3Panel) {
            if (isSwitchingLevel2) {
                resetLevel3Previews(targetLevel3Panel);
            }
            targetLevel3Panel.setAttribute("data-visible", "true");
        }
        else if (emptyState) {
            const level2Title = level2Item.textContent?.trim() || "";
            const emptyStateMessage = emptyState.querySelector("[data-empty-state-message]");
            if (emptyStateMessage) {
                const messageTemplate = emptyStateMessage.getAttribute("data-message-template") ||
                    "Visit the {0} page for more information";
                emptyStateMessage.textContent = messageTemplate.replace("{0}", level2Title);
            }
            emptyState.setAttribute("data-visible", "true");
        }
    };
    const clearLevel2Hover = () => {
        if (hoveredLevel2Item) {
            hoveredLevel2Item.classList.remove("bg-primary", "text-white");
            hoveredLevel2Item.classList.add("text-gray-700", "hover:bg-gray-100");
            hoveredLevel2Item = null;
        }
        if (menuPanel) {
            menuPanel.querySelectorAll("[data-level3-panel], [data-empty-state]").forEach((el) => {
                el.setAttribute("data-visible", "false");
            });
            resetLevel3Previews();
        }
    };
    // =========================================================================
    // LEVEL 3 PREVIEW FUNCTIONS (Desktop Mega Menu)
    // Show the image/description of the hovered Level 3 item beside the list
    // =========================================================================
    const handleLevel3Hover = (level3Item) => {
        const panel = level3Item.closest("[data-level3-panel]");
        const itemId = level3Item.getAttribute("data-level3-preview-id");
        if (!panel || !itemId)
            return;
        if (level3Item.getAttribute("data-active") === "true")
            return;
        panel.querySelectorAll("[data-level3-preview-id]").forEach((el) => {
            el.setAttribute("data-active", el === level3Item ? "true" : "false");
        });
        panel.querySelectorAll("[data-level3-preview]").forEach((el) => {
            el.setAttribute("data-visible", el.getAttribute("data-level3-preview") === itemId ? "true" : "false");
        });
    };
    const resetLevel3Previews = (scope = menuPanel) => {
        if (!scope)
            return;
        scope.querySelectorAll("[data-level3-preview-id]").forEach((el) => {
            el.setAttribute("data-active", el.getAttribute("data-level3-default") === "true" ? "true" : "false");
        });
        scope.querySelectorAll("[data-level3-preview]").forEach((el) => {
            el.setAttribute("data-visible", el.getAttribute("data-level3-default") === "true" ? "true" : "false");
        });
    };
    // =========================================================================
    // MOBILE MENU FUNCTIONS - Just show/hide server-rendered panels
    // =========================================================================
    let activeMobilePanel = null;
    const openMobileMenu = () => {
        if (!mobileMenu)
            return;
        isMobileMenuOpen = true;
        if (hamburgerIcon) {
            hamburgerIcon.setAttribute("data-state", "active");
        }
        resetMobilePanels();
        mobileMenu.setAttribute("data-state", "open");
        lockScrollMobile();
        closeMegaMenu();
    };
    const closeMobileMenu = () => {
        if (!mobileMenu)
            return;
        isMobileMenuOpen = false;
        if (hamburgerIcon) {
            hamburgerIcon.removeAttribute("data-state");
        }
        mobileMenu.setAttribute("data-state", "closing");
        setTimeout(() => {
            mobileMenu.removeAttribute("data-state");
            resetMobilePanels();
        }, 350);
        unlockScrollMobile();
    };
    const resetMobilePanels = () => {
        if (mobileLevel0) {
            mobileLevel0.setAttribute("data-panel-state", "active");
        }
        mobilePanels.forEach((panel) => {
            panel.setAttribute("data-panel-state", "hidden");
        });
        activeMobilePanel = null;
        document.querySelectorAll("[data-accordion-content], [data-accordion-icon]").forEach((el) => {
            el.setAttribute("data-expanded", "false");
        });
    };
    const openMobilePanel = (panelSlug) => {
        const panel = document.querySelector(`[data-mobile-panel="${panelSlug}"]`);
        if (!panel)
            return;
        const currentVisiblePanel = activeMobilePanel || mobileLevel0;
        if (!currentVisiblePanel)
            return;
        currentVisiblePanel.setAttribute("data-panel-state", "hidden-left");
        panel.setAttribute("data-panel-state", "active");
        activeMobilePanel = panel;
    };
    const closeMobilePanel = () => {
        if (!activeMobilePanel)
            return;
        const backBtn = activeMobilePanel.querySelector("[data-action='mobile-nav-back']");
        const fromLevel = backBtn?.getAttribute("data-from-level");
        let parentPanel = null;
        if (fromLevel === "1") {
            parentPanel = mobileLevel0;
        }
        else {
            const currentPanelId = activeMobilePanel.getAttribute("data-mobile-panel") || "";
            const lastDashIndex = currentPanelId.lastIndexOf("-");
            if (lastDashIndex > 0) {
                const parentPanelId = currentPanelId.substring(0, lastDashIndex);
                parentPanel = document.querySelector(`[data-mobile-panel="${parentPanelId}"]`);
            }
        }
        if (!parentPanel) {
            parentPanel = mobileLevel0;
        }
        activeMobilePanel.setAttribute("data-panel-state", "hidden");
        parentPanel.setAttribute("data-panel-state", "active");
        activeMobilePanel = parentPanel === mobileLevel0 ? null : parentPanel;
    };
    const toggleMobileMenu = () => {
        if (isMobileMenuOpen) {
            closeMobileMenu();
        }
        else {
            openMobileMenu();
        }
    };
    // =========================================================================
    // HOVER HANDLERS (Desktop) - Show/hide server-rendered panels
    // =========================================================================
    const handleNavTabHoverEnter = (navTab, menuSlug) => {
        if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            hoverTimeout = null;
        }
        // We intentionally do NOT set data-state="active" on the hovered tab.
        // data-state="active" is reserved for the current-page tab (set server-side
        // and preserved by resetNavTabStates). Mixing the two meanings caused the
        // hovered tab to inherit the "active" styling (primary color) instead of
        // the normal hover styling. CSS :hover handles the hovered tab; the
        // open-menu source is identified by aria-expanded="true" set in
        // openMegaMenuForItem.
        const contentSection = menuSlug
            ? document.querySelector(`[data-menu-content="${menuSlug}"]`)
            : null;
        if (contentSection) {
            openMegaMenuForItem(navTab, menuSlug);
        }
        else if (isMenuOpen) {
            closeMegaMenu();
        }
    };
    const handleMenuHoverLeave = () => {
        hoverTimeout = setTimeout(() => {
            closeMegaMenu();
        }, 500);
    };
    const handleNavTabHoverLeave = (navTab) => {
        if (!isCurrentPageTab(navTab)) {
            navTab.removeAttribute("data-state");
        }
    };
    // =========================================================================
    // EVENT LISTENERS
    // =========================================================================
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    allNavTabs.forEach((tab) => {
        const navTab = tab;
        const menuSlug = navTab.getAttribute("data-nav-tab") || "";
        const hasSubmenu = navTab.getAttribute("data-has-submenu") === "true";
        if (!isTouchDevice) {
            navTab.addEventListener("mouseenter", () => handleNavTabHoverEnter(navTab, menuSlug));
            if (hasSubmenu) {
                navTab.addEventListener("mouseleave", () => {
                    handleNavTabHoverLeave(navTab);
                    handleMenuHoverLeave();
                });
            }
            else {
                navTab.addEventListener("mouseleave", () => handleNavTabHoverLeave(navTab));
            }
        }
        // Tablet/Touch device behavior: first touch opens menu, second touch follows link
        if (isTouchDevice && hasSubmenu) {
            navTab.addEventListener("click", (e) => {
                const contentSection = document.querySelector(`[data-menu-content="${menuSlug}"]`);
                const isMenuOpenForThisItem = contentSection && contentSection.classList.contains("block");
                if (!isMenuOpenForThisItem && contentSection) {
                    e.preventDefault();
                    handleNavTabHoverEnter(navTab, menuSlug);
                }
            });
        }
        // Keyboard accessibility - Desktop
        // Focus behavior: Set active state but DON'T auto-open menu
        navTab.addEventListener("focus", () => {
            allNavTabs.forEach((tab) => {
                if (tab !== navTab && !isCurrentPageTab(tab)) {
                    tab.removeAttribute("data-state");
                }
            });
            navTab.setAttribute("data-state", "active");
        });
        // Keyboard navigation: Enter to open menu and move focus to first Level 2 item
        navTab.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                if (hasSubmenu && menuSlug) {
                    const contentSection = document.querySelector(`[data-menu-content="${menuSlug}"]`);
                    const isMenuOpenForThisItem = contentSection && contentSection.classList.contains("block");
                    if (!isMenuOpenForThisItem) {
                        e.preventDefault();
                        handleNavTabHoverEnter(navTab, menuSlug);
                        setTimeout(() => {
                            const firstLevel2Item = contentSection?.querySelector("[data-hover-level2-item]");
                            if (firstLevel2Item) {
                                firstLevel2Item.focus();
                            }
                        }, 50);
                    }
                }
            }
            // Space key: same as Enter for consistency
            if (e.key === " ") {
                if (hasSubmenu && menuSlug) {
                    e.preventDefault();
                    const contentSection = document.querySelector(`[data-menu-content="${menuSlug}"]`);
                    const isMenuOpenForThisItem = contentSection && contentSection.classList.contains("block");
                    if (!isMenuOpenForThisItem) {
                        handleNavTabHoverEnter(navTab, menuSlug);
                        setTimeout(() => {
                            const firstLevel2Item = contentSection?.querySelector("[data-hover-level2-item]");
                            if (firstLevel2Item) {
                                firstLevel2Item.focus();
                            }
                        }, 50);
                    }
                }
            }
            // Escape key to close mega menu
            if (e.key === "Escape" && isMenuOpen) {
                closeMegaMenu();
                navTab.focus();
            }
        });
    });
    if (menuPanel) {
        menuPanel.addEventListener("mouseenter", () => {
            if (hoverTimeout) {
                clearTimeout(hoverTimeout);
                hoverTimeout = null;
            }
        });
        menuPanel.addEventListener("mouseleave", handleMenuHoverLeave);
    }
    if (!isTouchDevice && menuPanel) {
        menuPanel.addEventListener("mouseover", (e) => {
            if (!isMenuOpen)
                return;
            const level2Item = e.target.closest("[data-hover-level2-item]");
            if (level2Item) {
                handleLevel2Hover(level2Item);
            }
        });
    }
    if (menuPanel) {
        menuPanel.addEventListener("pointerover", (e) => {
            if (!isMenuOpen)
                return;
            const level3Item = e.target.closest("[data-level3-preview-id]");
            if (level3Item) {
                handleLevel3Hover(level3Item);
            }
        });
    }
    if (menuPanel) {
        menuPanel.addEventListener("focusin", (e) => {
            if (!isMenuOpen)
                return;
            const level3Item = e.target.closest("[data-level3-preview-id]");
            if (level3Item) {
                handleLevel3Hover(level3Item);
            }
        });
    }
    if (isTouchDevice) {
        document.addEventListener("click", (e) => {
            const target = e.target;
            const level3Item = target.closest("[data-level3-preview-id]");
            if (level3Item && isMenuOpen && target.closest("a")) {
                const isActive = level3Item.getAttribute("data-active") === "true";
                if (!isActive) {
                    e.preventDefault();
                    handleLevel3Hover(level3Item);
                    return;
                }
            }
            const level2Item = target.closest("[data-hover-level2-item]");
            if (level2Item && isMenuOpen) {
                const level2Id = level2Item.getAttribute("data-hover-level2");
                const activeContentSection = menuPanel?.querySelector("[data-menu-content].block");
                if (level2Id && activeContentSection) {
                    const targetLevel3Panel = activeContentSection.querySelector(`[data-level3-panel="${level2Id}"]`);
                    if (targetLevel3Panel) {
                        const isContentVisible = targetLevel3Panel.getAttribute("data-visible") === "true";
                        if (!isContentVisible) {
                            e.preventDefault();
                            handleLevel2Hover(level2Item);
                        }
                    }
                }
            }
        });
    }
    document.addEventListener("keydown", (e) => {
        const target = e.target;
        const level2Item = target.closest("[data-hover-level2-item]");
        if (level2Item && isMenuOpen) {
            // Enter or Space: Show Level 3+ content and move focus
            if (e.key === "Enter" || e.key === " ") {
                const level2Id = level2Item.getAttribute("data-hover-level2");
                const activeContentSection = menuPanel?.querySelector("[data-menu-content].block");
                if (level2Id && activeContentSection) {
                    const targetLevel3Panel = activeContentSection.querySelector(`[data-level3-panel="${level2Id}"]`);
                    if (targetLevel3Panel) {
                        e.preventDefault();
                        const isContentVisible = targetLevel3Panel.getAttribute("data-visible") === "true";
                        if (!isContentVisible) {
                            handleLevel2Hover(level2Item);
                        }
                        setTimeout(() => {
                            const firstLevel3Link = targetLevel3Panel.querySelector("a");
                            if (firstLevel3Link) {
                                firstLevel3Link.focus();
                            }
                        }, 50);
                    }
                }
            }
            if (e.key === "Escape") {
                e.preventDefault();
                closeMegaMenu();
                const activeNavTab = element.querySelector("[data-nav-tab][data-state='active']");
                if (activeNavTab) {
                    activeNavTab.focus();
                }
            }
        }
    });
    // Level 3+ links keyboard support
    document.addEventListener("keydown", (e) => {
        const target = e.target;
        const isInLevel3Panel = target.closest("[data-level3-panel]");
        if (isInLevel3Panel && isMenuOpen && e.key === "Escape") {
            e.preventDefault();
            closeMegaMenu();
            const activeNavTab = element.querySelector("[data-nav-tab][data-state='active']");
            if (activeNavTab) {
                activeNavTab.focus();
            }
        }
    });
    menuBackdrop?.addEventListener("click", closeMegaMenu);
    closeButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            closeMegaMenu();
        });
    });
    mobileMenuToggle?.addEventListener("click", (e) => {
        e.preventDefault();
        toggleMobileMenu();
    });
    languageButton?.addEventListener("click", (e) => {
        e.stopPropagation();
        if (languageDropdown) {
            const isOpen = languageDropdown.getAttribute("data-state") === "open";
            if (isOpen) {
                languageDropdown.removeAttribute("data-state");
            }
            else {
                languageDropdown.setAttribute("data-state", "open");
            }
        }
    });
    // Mobile navigation drill buttons - open server-rendered panel
    document.addEventListener("click", (e) => {
        const target = e.target;
        const accordionRow = target.closest("[data-action='mobile-nav-accordion']");
        if (accordionRow) {
            const clickedLink = target.closest("[data-accordion-link]");
            if (clickedLink) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            const accordionTarget = accordionRow.getAttribute("data-accordion-target") || "";
            if (!accordionTarget)
                return;
            const accordionContent = document.querySelector(`[data-accordion-content="${accordionTarget}"]`);
            const accordionIcon = accordionRow.querySelector("[data-accordion-icon]");
            if (accordionContent) {
                const isExpanded = accordionContent.getAttribute("data-expanded") === "true";
                if (isExpanded) {
                    accordionContent.setAttribute("data-expanded", "false");
                    accordionRow.setAttribute("aria-expanded", "false");
                    if (accordionIcon) {
                        accordionIcon.setAttribute("data-expanded", "false");
                    }
                }
                else {
                    accordionContent.setAttribute("data-expanded", "true");
                    accordionRow.setAttribute("aria-expanded", "true");
                    if (accordionIcon) {
                        accordionIcon.setAttribute("data-expanded", "true");
                    }
                }
            }
            return;
        }
        const drillBtn = target.closest("[data-action='mobile-nav-drill']");
        if (drillBtn) {
            const targetPanel = drillBtn.getAttribute("data-target-panel") || "";
            if (targetPanel) {
                openMobilePanel(targetPanel);
            }
            return;
        }
        const backBtn = target.closest("[data-action='mobile-nav-back']");
        if (backBtn) {
            closeMobilePanel();
            return;
        }
        if (languageDropdown && languageDropdown.getAttribute("data-state") === "open") {
            const isClickInsideDropdown = languageDropdown.contains(target);
            const isClickOnButton = languageButton?.contains(target);
            if (!isClickInsideDropdown && !isClickOnButton) {
                languageDropdown.removeAttribute("data-state");
            }
        }
    });
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            if (isMenuOpen)
                closeMegaMenu();
            if (isMobileMenuOpen)
                closeMobileMenu();
        }
    });
    resetNavTabStates();
    return () => { };
}
